<template>
  <div
    v-if="isShow"
    :class="[
      { 'as-statistic-home': isHomePage },
      `as-parent-statics as-parent-statics-${siteName}`,
    ]"
  >
    <!-- HEAD -->
    <div v-if="isShowTab"
      class="as-nav-tabs-btn as-nav-tabs-btn__border"
      :class="`as-nav-tabs-btn-${siteName}`"
    >
      <div
        class="as-nav-item"
        v-for="tab of statistics"
        :key="tab.id"
        :class="{ active: activeTab === tab.matchStatus }"
        @click="activeTab = tab.matchStatus"
      >
        <span class="as-extra-item"></span>
        {{ getTabLabel(tab.matchStatus) }}
      </div>
    </div>
    <!-- <NoData v-else /> -->
    <div v-else>
      <StatisticsItem
        :statistics="dataDefault"
        :match="match"
        :isHomePage="isHomePage"
        :isDefault="true"
      />
    </div>
    <!-- CONTENT -->
    <div v-if="isShowTab" class="as-tab-content">
      <StatisticsItem
        v-for="statistic in statistics"
        :key="statistic?.id"
        v-show="activeTab === statistic.matchStatus"
        :statistics="statistic"
        :match="match"
        :isHomePage="isHomePage"
      />
    </div>
  </div>
  <NoData v-else />
</template>

  <script setup lang="ts">
import { defineProps, ref, computed, watch } from "vue";
import type { IStatistics, IMatch } from "~src/interfaces/tennis";
import StatisticsItem from "~src/components/statistics/tennis/StatisticsItem.vue";
import { getProcessedStats, initializeData } from "~src/helpers/tennis/index";
import NoData from "~src/components/NoData.vue";
import { usecommonStore } from "~src/stores/CommonStore";
const commonStore = usecommonStore();

interface IProps {
  statistics: IStatistics[];
  match: IMatch;
  isHomePage: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  isHomePage: false,
});

const siteName = computed(() => commonStore.getSiteName);
const dataDefault = initializeData();
const activeTab = ref<number>(100);

watch(
  () => props.statistics[0]?.matchStatus,
  (newStatus) => {
    if (newStatus !== undefined) {
      activeTab.value = Number(newStatus);
    }
  },
  { immediate: true }
);

const isShow = computed(() => {
  if (!statisticAll.value) {
    return false;
  }

  return true;
});

const statisticAll = computed<any>(() => {
  const data = props.statistics.length
    ? props.statistics[props.statistics.length - 1]
    : ({} as IStatistics);
  return data;
});

const isShowTab = computed(() => {
  if (!statisticAll.value.id) {
    return false;
  }
  const stats = getProcessedStats(props.match, statisticAll.value, false);
  return stats.length > 0;
});

const getTabLabel = (type: number | string): string | null | undefined => {
  switch (type) {
    case 100:
      return "Tất cả";
    case 51:
      return "SET 1";
    case 52:
      return "SET 2";
    case 53:
      return "SET 3";
    case 54:
      return "SET 4";
    case 55:
      return "SET 5";
    default:
      return undefined;
  }
};
</script>

<script lang="ts">
export default {};
</script>
